(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel {
    constructor(element) {
      this.hero = element;
      this.slides = this.hero.querySelectorAll('.hero__carousel-slide');
      this.dots = this.hero.querySelectorAll('.hero__carousel-dot');
      this.prevBtn = this.hero.querySelector('.hero__carousel-btn--prev');
      this.nextBtn = this.hero.querySelector('.hero__carousel-btn--next');
      
      this.currentSlide = 0;
      this.interval = parseInt(this.hero.dataset.carouselInterval) || 5000;
      this.transition = this.hero.dataset.carouselTransition || 'fade';
      this.pauseOnHover = this.hero.dataset.carouselPauseOnHover === 'true';
      this.autoplayTimer = null;
      
      this.init();
    }
    
    init() {
      if (this.slides.length <= 1) return;
      
      // Set first slide as active
      this.slides[0].classList.add('active');
      
      // Add event listeners
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }
      
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToSlide(index));
      });
      
      // Pause on hover
      if (this.pauseOnHover) {
        this.hero.addEventListener('mouseenter', () => this.pause());
        this.hero.addEventListener('mouseleave', () => this.play());
      }
      
      // Start autoplay
      this.play();
    }
    
    goToSlide(index) {
      if (index === this.currentSlide) return;
      
      const prevSlide = this.currentSlide;
      this.currentSlide = index;
      
      // Update slides
      this.slides.forEach((slide, i) => {
        slide.classList.remove('active', 'prev');
        if (i === this.currentSlide) {
          slide.classList.add('active');
        } else if (i === prevSlide) {
          slide.classList.add('prev');
        }
      });
      
      // Update dots
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === this.currentSlide);
      });
      
      // Handle videos
      this.handleVideoPlayback();
    }
    
    next() {
      const nextIndex = (this.currentSlide + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }
    
    prev() {
      const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }
    
    play() {
      this.pause();
      this.autoplayTimer = setInterval(() => this.next(), this.interval);
    }
    
    pause() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
    
    handleVideoPlayback() {
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (video) {
          if (i === this.currentSlide) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });
    }
  }
  
  // Initialize all carousels
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[data-carousel="true"]');
    carousels.forEach(carousel => new HeroCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
